import { createSelector } from 'reselect';

const selectGlobal = (state: any) => state.global;

export const makeSelectAuthUser = () =>
  createSelector(selectGlobal, globalState => (globalState ? globalState.authUser : undefined));
